import { ERole, User } from './user.model';

export class Professor extends User {

    constructor(uid:string) {
        super(uid);
        this.role = ERole.Professor;
    }

}